import React, { Component } from 'react';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import { Row, Col, Modal } from 'react-bootstrap';
import cookies from 'next-cookies';
import JsCookies from 'js-cookie';
import { _getFilterArray,_getCities } from '../../utils';
import Router from 'next/router';
import { citySelected } from '../../utils/gtagAction';
export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // locations: [
            //     {
            //         "id": 1,
            //         "name": 'Hyderabad',
            //         "image": 'Hyderabad.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Hyderabad' ? true :false,
            //         "className": 'city-box-support'
            //     },
            //     {
            //         "id": 2,
            //         "name": 'Bengaluru',
            //         "image": 'Bengaluru.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Bengaluru' ? true :false,
            //         "className": 'city-box-support'
            //     },
            //     {
            //         "id": 3,
            //         "name": 'Mumbai',
            //         "image": 'Mumbai.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Mumbai' ? true :false,
            //         "className": 'city-box-support12'
            //     },
            //     {
            //         "id": 4,
            //         "name": 'Delhi',
            //         "image": 'Delhi.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Delhi' ? true :false,
            //         "className": 'city-box-support12'
            //     },
            //     {
            //         "id": 5,
            //         "name": 'Chennai',
            //         "image": 'Chennai.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Chennai' ? true :false,
            //         "className": 'city-box-support1'
            //     },
            //     {
            //         "id": 6,
            //         "name": 'Kolkata',
            //         "image": 'Kolkata.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Kolkata' ? true :false,
            //         "className": 'city-box-support1'
            //     }
            // ],
            // otherCities: [
            //     {
            //         "id": 1,
            //         "name": 'Pune',
            //         "image": 'Hyderabad.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Pune' ? true :false,
            //         "className": 'city-box-support'
            //     },
            //     {
            //         "id": 2,
            //         "name": 'Gurgaon',
            //         "image": 'Bengaluru.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Gurgaon' ? true :false,
            //         "className": 'city-box-support'
            //     },
            //     {
            //         "id": 3,
            //         "name": 'Noida',
            //         "image": 'Mumbai.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Noida' ? true :false,
            //         "className": ''
            //     },
            //     {
            //         "id": 4,
            //         "name": 'Faridabad',
            //         "image": 'Delhi.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Faridabad' ? true :false,
            //         "className": ''
            //     },
            //     {
            //         "id": 5,
            //         "name": 'Ahmedabad',
            //         "image": 'Chennai.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Ahmedabad' ? true :false,
            //         "className": ''
            //     },
            //     {
            //         "id": 6,
            //         "name": 'Gandhinagar',
            //         "image": 'Kolkata.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Gandhinagar' ? true :false,
            //         "className": ''
            //     },
            //     {
            //         "id": 7,
            //         "name": 'Nagpur',
            //         "image": 'Bengaluru.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Nagpur' ? true :false,
            //         "className": ''
            //     },
            //     {
            //         "id": 8,
            //         "name": 'Vizag',
            //         "image": 'Mumbai.svg',
            //         "isChecked": cookies({"ctx":''}).location == 'Vizag' ? true :false,
            //         "className": ''
            //     }
            // ]
            locations: [],
            otherCities: []
        }
    }

    async componentDidMount() {
        let getAllCities = await _getCities()
        let obj = {name:cookies({"ctx":''}).location }
        let locations = await _getFilterArray(getAllCities.locations,obj)
        let otherCities = await _getFilterArray(getAllCities.otherCities,obj)
        this.setState({ locations : locations , otherCities : otherCities })
     }

    getLocation = (location) => {
        let { locations, otherCities } = this.state
        otherCities.map(res=>{res.isChecked = false}) 
        var cLocations = _getFilterArray(locations,location) 
        this.setState({ locations: cLocations, otherCities : this.state.otherCities })
        // document.cookie = `location=` + location.name;
        citySelected()
        JsCookies.set('location', location.name)
        Router.push("/city","/"+location.name);   
        this.props.handleClose()
    }

    getOtherLocation = (location) =>{
        let { locations, otherCities } = this.state
        locations.map(res=>{res.isChecked = false})  
        var cOtherCities = _getFilterArray(otherCities,location)
        this.setState({ locations: this.state.locations, otherCities : cOtherCities })
        // document.cookie = `location=` + location.name;
        citySelected()
        JsCookies.set('location', location.name)
        Router.push("/city","/"+location.name);
        this.props.handleClose()
    }

    render() {
        let { locations, otherCities } = this.state
        var city_name = cookies({"ctx":''}).location
        return (
            <Modal show={this.props.show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="select-city"
                onHide={city_name !== undefined ? this.props.handleClose : this.props.handleClose1}>
                <Modal.Body>
                {city_name !== undefined && <img src={`${publicRuntimeConfig.staticFolder}/images/close.png`} alt="select" className="tag-close float-right desktop" onClick={this.props.handleClose} />}  
                {city_name !== undefined && <img src={`${publicRuntimeConfig.staticFolder}/images/Back-Arrow.png`} alt="select" className="tag-close123 mobile" onClick={this.props.handleClose} />}                    
                    <div className="city-head text-center pt-3">Select City</div>
                    <div className="city-main">
                        <Row>
                            {locations.map((res, index) => (
                                <Col className="pr-0 mobile-prd" xs={4} md key={index}>
                                    <div className={res.isChecked ? "city-box city-active" : "city-box"} onClick={() => this.getLocation(res)}>
                                        {res.isChecked && <img src={`${publicRuntimeConfig.staticFolder}/images/select-city.svg`} alt="select" className="support-select" />}
                                        <div className="choose-city-name mobile">{res.name}</div>                                        
                                        <img src={(res.icon_path && res.icon_path != null) ? `https://api.gadgetzippy.com/cityIcons/${res.icon_path}` : `${publicRuntimeConfig.staticFolder}/images/Hyderabad.svg`} alt={res.name} className="city-box-support" />
                                        <div className="choose-city-name desktop">{res.name}</div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                    <div className="pl-sm-4 pr-sm-4 pt-sm-4 pb-sm-4">
                        <div className="other-city-head pl-3 mobile-other-cities">Other Cities</div>
                        {otherCities.map((res, index) => (
                            <div key={index} onClick={() =>this.getOtherLocation(res)}>
                                <div className={res.isChecked ? "other-city city-active" : "other-city"}>{res.name}
                                   {res.isChecked && <img src={`${publicRuntimeConfig.staticFolder}/images/select-city.svg`} alt="select" className="support-select-o" />}
                                </div>
                                <div className="city-divider"></div>
                            </div>
                        ))}
                    </div>
                    <div className="text-center cities-soon">We will be in other cities soon!</div>
                </Modal.Body>
            </Modal>
        )
    }
}
